import { ThemeColor, ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';

function setup(): void {
  ThemeService.setColors(ThemeColor.GROUP_BLUE, ThemeColor.GREEN);
  ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
  ThemeService.setNavigationTonalRange(ThemeTonalRange.BRIGHT);
}

export {
  setup,
};
